import React from 'react';
import { ReactComponent as FigReceiptComponent } from './FigReceipt.svg';

const FigReceipt = (props) => <FigReceiptComponent {...props} />;

export default FigReceipt;
